import React from "react";
import spin from "../spin.svg";
export default function Loader() {
  return (
    <div className="loading">
      <img src={spin} alt="spinner" width="120px" />
    </div>
  );
}
